/**
 * Constants for question management dropdowns
 * These provide predefined options instead of database-driven data
 */

export const QUESTION_TYPES = [
  'MCQ_SINGLE_CORRECT',
  'MCQ_MULTIPLE_CORRECT',
  'TRUE_FALSE',
  'FILL_IN_THE_BLANK_NUMERIC',
  'ESSAY',
  'MATCHING',
  'READING_COMPREHENSION',
];

export const DIFFICULTY_LEVELS = [
  'EASY',
  'MEDIUM',
  'HARD'
];

export const CLASS_LEVELS = [
  '8',
  '9',
  '10',
  '11',
  '12'
];

export const EXAM_TYPES = [
  'JEE_MAIN',
  'JEE_ADVANCED',
  'NEET',
  'BOARDS',
  'GATE',
  'CAT',
  'UPSC',
  'CLAT_UG',
  'EAMCET',
  'CUSTOM'
];

export const SUBJECTS = [
  'Mathematics',
  'Physics',
  'Chemistry',
  'Biology',
  'English',
  'General Knowledge',
  'Reasoning',
  'Computer Science',
  'Economics',
  'History',
  'Geography',
  'Political Science',
  // CLAT-specific subjects
  'English Language',
  'Current Affairs & GK',
  'Legal Reasoning',
  'Logical Reasoning',
  'Quantitative Techniques'
];

export const TOPICS_BY_SUBJECT = {
  'Mathematics': [
    'Algebra',
    'Arithmetic',
    'Geometry',
    'Trigonometry',
    'Calculus',
    'Statistics',
    'Probability',
    'Number Theory',
    'Coordinate Geometry',
    'Vectors'
  ],
  'Physics': [
    'Mechanics',
    'Thermodynamics',
    'Optics',
    'Electricity',
    'Magnetism',
    'Modern Physics',
    'Waves',
    'Atomic Physics',
    'Nuclear Physics'
  ],
  'Chemistry': [
    'Organic Chemistry',
    'Inorganic Chemistry',
    'Physical Chemistry',
    'Chemical Bonding',
    'Periodic Table',
    'Acids and Bases',
    'Redox Reactions',
    'Thermochemistry'
  ],
  'Biology': [
    'Cell Biology',
    'Genetics',
    'Evolution',
    'Ecology',
    'Human Physiology',
    'Plant Biology',
    'Molecular Biology',
    'Biotechnology'
  ]
};

/**
 * Get topics for a given subject
 */
export const getTopicsForSubject = (subject) => {
  if (!subject) return [];
  
  return TOPICS_BY_SUBJECT[subject] || ['General', 'Basic Concepts', 'Advanced Topics'];
};

/**
 * Validation functions
 */
export const isValidQuestionType = (questionType) => {
  return questionType && QUESTION_TYPES.includes(questionType.toUpperCase());
};

export const isValidDifficultyLevel = (difficultyLevel) => {
  return difficultyLevel && DIFFICULTY_LEVELS.includes(difficultyLevel.toUpperCase());
};

export const isValidExamType = (examType) => {
  return examType && EXAM_TYPES.includes(examType.toUpperCase());
};

export const isValidSubject = (subject) => {
  return subject && SUBJECTS.includes(subject);
};
